import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import { CssBaseline } from "@mui/material";
import App from "./App";
import theme from "../config/theme";
import "./index.css";
import "./mobile.css";
import { AuthProvider } from "./context/auth-provider";
import { DataProvider } from "./context/data-provider";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <AuthProvider>
            <DataProvider>
                <BrowserRouter>
                    <ThemeProvider theme={theme}>
                        <CssBaseline />
                        <App />
                    </ThemeProvider>
                </BrowserRouter>
            </DataProvider>
        </AuthProvider>
    </React.StrictMode>
);
